module.exports = __webpack_public_path__ + "57eae2194e43a18b500fd8537acb034a.gif";